/**
 * Vrai seulement pour un lien externe réellement navigable : une adresse
 * absolue en `http:` ou `https:`.
 *
 * <p>Ces liens viennent de la base — visio d'une séance, support de cours,
 * ressource d'aide — et finissent dans un `window.open`, un `location.assign`
 * ou le `src` d'une iframe, qu'Angular ne désinfecte pas. Le serveur les
 * valide à l'enregistrement ; cette seconde vérification tient parce qu'une
 * donnée entrée avant ce contrôle reste en base, et qu'un `javascript:` s'y
 * exécuterait dans la session de celui qui clique.</p>
 *
 * <p>Liste blanche, et analyse par `URL` plutôt qu'une expression : c'est le
 * même analyseur que celui du navigateur, qui ignore les espaces de tête et
 * les tabulations glissées dans le schéma (`java\tscript:`). Une adresse
 * relative est refusée : un lien externe sans schéma (`meet.google.com/…`)
 * mènerait sur une page de l'application.</p>
 */
export function isNavigableUrl(url: string | null | undefined): url is string {
  if (!url) return false;
  try {
    const scheme = new URL(url).protocol;
    return scheme === 'http:' || scheme === 'https:';
  } catch {
    return false;
  }
}
